import styles from './InviteGuestsFromHostedEvents.module.scss';

import { useDispatch } from 'react-redux';

import { useGetHostedEvents } from 'legacy/user/hooks';
import { useInviteGuestsFromHostedEventMutation } from 'legacy/events/hooks';

import { showModal } from 'legacy/actions/modalActions';

import Modal from 'legacy/common/components/modal/Modal';

import * as toast from 'legacy/common/utils/toast';
import Loader from 'legacy/common/components/layout/Loader';
import { EventLean } from 'legacy/events/types';

type InviteGuestsFromHostedEventsProps = {
  destinationEventId: string;
  onClose: () => void;
};

const getMessage = (event: EventLean) => {
  if (event.totalGuests === 1) {
    return `Are you sure you want to invite the guest from "${event.title}"?`;
  }

  if (event.totalGuests === 2) {
    return `Are you sure you want to invite both the guests from "${event.title}"?`;
  }

  return `Are you sure you want to invite all ${event.totalGuests} guests from "${event.title}"?`;
};

const InviteGuestsFromHostedEvents: React.FC<
  InviteGuestsFromHostedEventsProps
> = ({ destinationEventId, onClose }) => {
  const dispatch = useDispatch();
  const { mutate, isLoading: isLoadingInviteGuestsMutation } =
    useInviteGuestsFromHostedEventMutation();

  const { data, isLoading: isLoadingHostedEvents } = useGetHostedEvents();
  const inviteGuests = (event: EventLean) => {
    dispatch(
      showModal('CONFIRMATION', {
        type: 'success',
        message: getMessage(event),
        onSuccess: ({ close }) => {
          close();

          mutate(
            {
              eventId: destinationEventId,
              sourceEventId: event._id
            },
            {
              onSuccess: () => {
                onClose();
                toast.success(
                  `Success! Guests from ${event.title} have been invited`
                );
              },
              onError: (error) => {
                toast.error(error.message);
              }
            }
          );
        }
      })
    );
  };

  const previouslyHostedEvents = data?.filter(
    (event) => event._id !== destinationEventId && event.totalGuests
  );

  return (
    <Modal visible onClose={onClose}>
      <Loader isLoading={isLoadingHostedEvents}>
        <div className={styles.wrapper}>
          <div className={styles.title}>Invite guests from hosted event</div>
          <Loader isOverlay isLoading={isLoadingInviteGuestsMutation}>
            {previouslyHostedEvents?.length === 0 && (
              <div className={styles.empty}>
                You have not hosted any other events.
              </div>
            )}

            <div className={styles.listWrapper}>
              {previouslyHostedEvents?.map((event) => (
                <div
                  key={event._id}
                  className={styles.event}
                  onClick={() => {
                    inviteGuests(event);
                  }}
                >
                  <img src={event?.photo?.url} />
                  <div className={styles.eventTitle}>{event?.title}</div>
                  <div className={styles.guests}>
                    Total Guests: {event?.totalGuests}
                  </div>
                </div>
              ))}
            </div>
          </Loader>
        </div>
      </Loader>
    </Modal>
  );
};

export default InviteGuestsFromHostedEvents;
